import React from "react";
import styles from "./HowSecured.module.css";

const HowSecured = () => {
  const steps = [
    {
      number: 1,
      title: "Client-Side Processing",
      description:
        "We do all image compression in your browser. Your files never leave your device, meaning complete privacy.",
      icon: "🔒",
    },
    {
      number: 2,
      title: "No Server Storage",
      description:
        "We do not upload your images to a server. Once compressed, the files are immediately available for you to download - no temporary storage.",
      icon: "🚫",
    },
    {
      number: 3,
      title: "Military-Grade Encryption",
      description:
        "In the event that you choose to upload files (which is optional), the files are sent encrypted with AES-256 - the strongest encryption available - to keep your files secure while in transit.",
      icon: "🛡️",
    },
  ];

  return (
    <div className={styles.howToUse}>
      <h1 className={styles.sectionTitle}>Why Our Tool is Secure</h1>
      <p className={styles.sectionSubtitle}>
        Your privacy is our top priority - here's how we protect it
      </p>

      <div className={styles.stepsContainer}>
        {steps.map((step) => (
          <div key={step.number} className={styles.stepCard}>
            <div className={styles.stepHeader}>
              <span className={styles.stepNumber}>{step.number}</span>
              <span className={styles.stepIcon}>{step.icon}</span>
            </div>
            <h3 className={styles.stepTitle}>{step.title}</h3>
            <p className={styles.stepDescription}>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowSecured;
